import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import logo from '../assets/Blue.png';
import { Link, useLocation } from 'react-router-dom'; // Import Link
import { Card, CardActions, Grid, MenuItem, Popover, Menu, Collapse } from '@mui/material';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import Tab from '@mui/material/Tab';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import { useNavigate } from 'react-router-dom';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import DvrIcon from '@mui/icons-material/Dvr';
import AppShortcutIcon from '@mui/icons-material/AppShortcut';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import styled from '@emotion/styled';
import { ExpandLess, ExpandMore } from '@mui/icons-material'; // Icons for expand/collapse
import './index.css'
// import MenuIcon from '@mui/icons-material/Menu';
// import { Link } from 'react-router-dom';
const drawerWidth = 240;

const navItems = [
  { name: 'Home', path: '/' },
  { name: 'Offering' },
  // { name: 'Technology', path: '/technology' },
  { name: 'About', path: '/about' },
  // { name: 'Career', path: '/career' },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography >{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [state, setState] = React.useState({
    top: false,
  });
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'offering-popover' : undefined;
  const [openDropdown, setOpenDropdown] = useState(false);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const handleDropdownToggle = () => {
    setOpenDropdown((prev) => !prev); // Toggle the dropdown state
  };

  // Handle sub-item navigation and close the drawer after navigating
  const handleSubItemClick = (path) => {
    navigate(path); // Navigate to the selected page
    handleDrawerToggle(); // Close the drawer after navigating
  };
  const drawer = (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2, marginBottom: 0, marginTop: 0 }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
          <img src={logo} alt="Logo" style={{ height: '60px' }} />
        </Link>
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <React.Fragment key={item.name}>
            {item.name === 'Offering' ? (
              <>
                {/* "Offering" list item with expand/collapse functionality */}
                <ListItemButton sx={{ textAlign: 'left' }} onClick={handleDropdownToggle}>
                  <ListItemText primary={<Typography sx={{ color: 'black' }}>{item.name}</Typography>} />
                  {openDropdown ? <ExpandLess /> : <ExpandMore />} {/* Show the appropriate icon */}
                </ListItemButton>
                {/* Collapsible list of dropdown items */}
                <Collapse in={openDropdown} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton sx={{ pl: 4 }} onClick={() => handleSubItemClick('/offering/artificialintelligence')}>
                      <ListItemText
                        primary={
                          <Typography className="poppins-regular">
                            Artificial Intelligence
                          </Typography>
                        }
                      />
                    </ListItemButton>

                    <ListItemButton sx={{ pl: 4 }} onClick={() => handleSubItemClick('/offering/CustomerSoftDev')}>
                      <ListItemText
                        primary={
                          <Typography className="poppins-regular">
                            Custom Software Development
                          </Typography>
                        }
                      />
                    </ListItemButton>

                    <ListItemButton sx={{ pl: 4 }} onClick={() => handleSubItemClick('/offering/rpa')}>
                      <ListItemText
                        primary={
                          <Typography className="poppins-regular">
                            RPA
                          </Typography>
                        }
                      />
                    </ListItemButton>

                    <ListItemButton sx={{ pl: 4 }} onClick={() => handleSubItemClick('/offering/security')}>
                      <ListItemText
                        primary={
                          <Typography className="poppins-regular">
                            Security
                          </Typography>
                        }
                      />
                    </ListItemButton>

                    <ListItemButton sx={{ pl: 4 }} onClick={() => handleSubItemClick('/offering/businessprocessservices')}>
                      <ListItemText
                        primary={
                          <Typography className="poppins-regular">
                            Business Process Services
                          </Typography>
                        }
                      />
                    </ListItemButton>

                    <ListItemButton sx={{ pl: 4 }} onClick={() => handleSubItemClick('/offering/consultancy')}>
                      <ListItemText
                        primary={
                          <Typography className="poppins-regular">
                            Consultancy
                          </Typography>
                        }
                      />
                    </ListItemButton>
                  </List>
                </Collapse>
              </>
            ) : (
              <Link to={item.path} style={{ textDecoration: 'none', color: 'black' }}>
                <ListItemButton
                  sx={{ textAlign: 'left' }}
                  onClick={handleDrawerToggle} // Close drawer when a normal item is clicked
                >
                  <ListItemText primary={<Typography className="poppins-regular" sx={{ color: 'black' }}>{item.name}</Typography>} />
                </ListItemButton>
              </Link>
            )}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;
  const handleChange = (event, newValue) => {
    setValue(newValue);
  }
  const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    position: 'relative',
    padding: '10px 20px',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      // Change background color on hover
      '&::after': {
        // content: '" -->"', // Arrow text
        position: 'absolute',
        right: '10px', // Position of the arrow
        opacity: 1,
        transition: 'opacity 0.3s',
        // Transition effect for the arrow
      },
    },
  }));
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar component="nav" elevation={4} sx={{ backgroundColor: "white" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>

          {/* Logo for large screens (sm and up) */}
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}  // Only show on sm and above
          >
            <Link
              to="/"
              style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
            >
              <img src={logo} alt="Logo" style={{ height: '60px' }} />
            </Link>
          </Typography>


          {/* Logo for small screens (xs only) */}
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 0, display: { xs: 'block', sm: 'none' } }}  // Only show on xs
          >
            <Link
              to="/"
              style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
            >
              <img src={logo} alt="Logo" style={{ height: '60px' }} />
            </Link>
          </Typography>
          {/* Menu Icon for small screens */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}  // Only show on xs
          >
            <MenuIcon style={{ color: "black" }} />
          </IconButton>





          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map((item) => {
              const isActive = location.pathname === item.path; // Check if current path matches item path

              return (
                item.name === 'Offering' ? (
                  <Button
                    key={item.name}
                    onClick={handlePopoverOpen} // Open popover on click
                    sx={{ color: '#000' }} // Adjust color if necessary
                  >
                    <Typography variant='h6'>{item.name}</Typography>
                  </Button>
                ) : (
                  <Link key={item.name} to={item.path || '#'} style={{ textDecoration: 'none' }}>
                    <Button
                      sx={{

                        color: isActive ? 'white' : 'black' // Change text color based on isActive state
                      }}
                    >
                      <Typography variant='h6' sx={{

                        color: isActive ? '#0B77A8' : 'black' // Change text color based on isActive state
                      }}
                      >{item.name}</Typography>
                    </Button>
                  </Link>
                )
              );
            })}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Popover for Offering */}
      <Popover

        id={open ? 'offering-popover' : undefined}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            backgroundColor: '#1166A6', // Replace 'yourColorHere' with the desired background color
            color: 'white',
            borderRadius: "20px"// Optional: set text color
          },
        }}
      >
        <div>
          <StyledMenuItem component={Link} to="/offering/artificialintelligence" onClick={handleClose} >
            <Typography variant="body1">Artificial Intelligence</Typography>
          </StyledMenuItem>

          <StyledMenuItem component={Link} to="/offering/CustomerSoftDev" onClick={handleClose}>
            <Typography variant="body1">Custom Software Development</Typography>
          </StyledMenuItem>

          {/* <StyledMenuItem component={Link} to="/offering/BlockChain" onClick={handleClose}>
            <Typography variant="body1">Blockchain</Typography>
          </StyledMenuItem> */}
          {/* <StyledMenuItem component={Link} to="/offering/dataanalytics" onClick={handleClose}>
            <Typography variant="body1">Data Analytics</Typography>
          </StyledMenuItem> */}
          <StyledMenuItem component={Link} to="/offering/rpa" onClick={handleClose}>
            <Typography variant="body1">RPA</Typography>
          </StyledMenuItem>
          <StyledMenuItem component={Link} to="/offering/security" onClick={handleClose}>
            <Typography variant="body1">Security</Typography>
          </StyledMenuItem>
          <StyledMenuItem component={Link} to="/offering/businessprocessservices" onClick={handleClose}>
            <Typography variant="body1">Business Process Services</Typography>
          </StyledMenuItem>
          <StyledMenuItem component={Link} to="/offering/consultancy" onClick={handleClose}>
            <Typography variant="body1">Consultancy</Typography>
          </StyledMenuItem>
        </div>
      </Popover>
      <nav>
        {/* Offering Drawer */}


        {/* Mobile Drawer */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  window: PropTypes.func,
};

export default DrawerAppBar;
